import { Stack } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const StyledHeaderDesktop = styled(Stack)(({ theme }) => ({
  width: '100%',
  paddingInline: theme.spacing(8),
  borderBottom: '1px solid',
  borderColor: theme.palette.text.fourth,
  [theme.breakpoints.up('xl')]: {
    paddingInline: theme.spacing(20),
  },
  [theme.breakpoints.up('gs')]: {
    paddingInline: 0,
  },
  '.header--desktop': {
    [theme.breakpoints.up('gs')]: {
      width: theme.spacing(650),
      marginInline: 'auto',
      paddingInline: theme.spacing(20),
    },
  },
}));

interface StyledHeaderContentProps {
  isTransparent?: boolean;
}

/**
 * Main header content wrapper - holds logo, menu, and actions
 * Handles transparent/default background states
 */
export const StyledHeaderContent = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'isTransparent',
})<StyledHeaderContentProps>(({ theme, isTransparent }) => ({
  alignItems: 'center',
  alignSelf: 'center',
  width: '100%',
  height: theme.spacing(19),
  background: isTransparent ? 'transparent' : theme.palette.background.default,
  flexDirection: 'row',
  justifyContent: 'space-between',
}));

/**
 * Left section - contains mobile menu, logo, discord, and youtube
 */
export const StyledLeftSection = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: 0,
});

/**
 * Right section - contains order button and icon actions
 */
export const StyledRightSection = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(6),
}));

/**
 * Icon buttons group - balance, cart, notifications, profile, language
 */
export const StyledIconButtonsGroup = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),
}));
